import { t } from 'app/i18l'
import { useCallback } from 'react'
import { FloatingActionButton, Item } from 'shared/components/fab'
import { AddFileFolderModalType } from './add_file_folder_modal'

const FABItems: Item[] = [
  { name: 'addFile', title: t('upload'), icon: 'file' },
  { name: 'addUrl', title: t('addLink'), icon: 'link' },
  { name: 'addFolder', title: t('addFolder'), icon: 'folder' },
]

interface AddFileFolderModalFABProps {
  onPressAddFileFolderModal: (type: AddFileFolderModalType) => void
  marginBottom?: number
  marginRight?: number
  useBottomInset?: boolean
}

export const AddFileFolderFAB = ({
  marginBottom,
  marginRight,
  onPressAddFileFolderModal,
  useBottomInset,
}: AddFileFolderModalFABProps) => {
  const onPressFloatingActionButtonItem = useCallback(
    (itemName: string) => {
      switch (itemName) {
        case 'addFile':
          onPressAddFileFolderModal('file')
          break
        case 'addFolder':
          onPressAddFileFolderModal('folder')
          break
        case 'addUrl':
          onPressAddFileFolderModal('url')
      }
    },
    [onPressAddFileFolderModal]
  )

  return (
    <FloatingActionButton
      items={FABItems}
      onPressItem={onPressFloatingActionButtonItem}
      marginBottom={marginBottom}
      marginRight={marginRight}
      useBottomInset={useBottomInset}
    />
  )
}
